import SuperFetch from 'library/helpers/superFetch';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Notification } from 'zComponents/atoms';
import { maintenanceActions } from './slice';

export function* loadMaintenanceLog() {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Fetch all maintenance devices logs
		const devicesMaintenance = yield call(() => SuperFetch.get('/maintenance'));

		if (devicesMaintenance.statusCode === 200) {
			yield put(maintenanceActions.loadMaintenanceLogSuccess({ orgID, data: devicesMaintenance.data }));
		} else {
			throw Error(
				devicesMaintenance.error.message ||
					devicesMaintenance.error ||
					'Failed to load maintenance devices data.'
			);
		}
	} catch (error) {
		yield put(maintenanceActions.loadMaintenanceLogError(error));
	}
}

export function* addMaintenanceLogs(action) {
	try {
		// Add maintenance log
		const addMaintenanceLog = yield call(() => SuperFetch.post('/maintenance', action.payload, {}));

		if (addMaintenanceLog.statusCode === 200) {
			yield put(maintenanceActions.addMaintenanceLogSuccess());
		} else {
			throw Error(addMaintenanceLog.error.message || addMaintenanceLog.error || 'Failed to add maintenance log.');
		}
	} catch (error) {
		// The drawer optimistically flips to the log tab on submit — without a
		// toast a failed save was completely invisible (entry just absent)
		Notification('error', error.message || 'Failed to add maintenance log.');
		yield put(maintenanceActions.addMaintenanceLogError(error.message));
	}
}

//🔥 Actions after Add maintenance log/
export function* addMaintenanceSuccess() {
	yield put(maintenanceActions.loadMaintenanceLog());
}

export function* deleteMaintenanceLogs(action) {
	try {
		//Delete maintenance log
		const deleteMaintenanceLog = yield call(() => SuperFetch.delete(`/maintenance/${action.payload}`, {}, {}));

		if (deleteMaintenanceLog.statusCode === 200) {
			yield put(maintenanceActions.deleteMaintenanceLogSuccess());
		} else {
			throw Error(
				deleteMaintenanceLog.error.message || deleteMaintenanceLog.error || 'Failed to delete maintenance log.'
			);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to delete maintenance log.');
		yield put(maintenanceActions.deleteMaintenanceLogError(error.message));
	}
}

//🔥 Actions after Delete maintenance log
export function* deleteMaintenanceSuccess() {
	yield put(maintenanceActions.loadMaintenanceLog());
}

export default function* maintenanceSaga() {
	yield takeLatest(maintenanceActions.loadMaintenanceLog, loadMaintenanceLog);
	yield takeLatest(maintenanceActions.addMaintenanceLog, addMaintenanceLogs);
	yield takeLatest(maintenanceActions.addMaintenanceLogSuccess, addMaintenanceSuccess);
	yield takeLatest(maintenanceActions.deleteMaintenanceLog, deleteMaintenanceLogs);
	yield takeLatest(maintenanceActions.deleteMaintenanceLogSuccess, deleteMaintenanceSuccess);
}
